var _excluded = ["id", "selected", "children", "handleClose", "onClick"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, Flex, getPaletteColor } from 'pcln-design-system';
import { Check as CheckIcon } from 'pcln-icons';
var MenuButton = styled(Button).withConfig({
  displayName: "MenuItem__MenuButton",
  componentId: "sc-160wq6f-0"
})(["display:flex;justify-content:space-between;align-items:center;border:2px solid transparent;border-radius:6px;color:", ";outline:none;padding:12px;&:hover{background-color:", ";}", ""], getPaletteColor('text.dark'), getPaletteColor('base'), function (props) {
  return props.selected ? "background-color: ".concat(getPaletteColor('background.base')(props), ";") : "background-color: ".concat(getPaletteColor('background.lightest')(props), ";");
});
var MenuItem = /*#__PURE__*/React.forwardRef(function MenuItem(_ref, ref) {
  var id = _ref.id,
      selected = _ref.selected,
      children = _ref.children,
      handleClose = _ref.handleClose,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, _excluded);

  var handleClick = useCallback(function () {
    onClick && onClick();
    handleClose && handleClose();
  }, [onClick, handleClose]);
  return /*#__PURE__*/React.createElement(MenuButton, _extends({
    id: id,
    ref: ref,
    role: "option",
    "aria-selected": selected,
    selected: selected,
    onClick: handleClick
  }, props), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, children), selected && /*#__PURE__*/React.createElement(CheckIcon, {
    title: "check",
    size: 20,
    ml: 3
  }));
});
MenuItem.displayName = 'MenuItem';
MenuItem.propTypes = {
  id: PropTypes.string,
  color: PropTypes.string,
  selected: PropTypes.bool,
  children: PropTypes.node,
  handleClose: PropTypes.func,
  onClick: PropTypes.func
};
MenuItem.defaultProps = {
  color: 'primary'
};
export default /*#__PURE__*/memo(MenuItem);